import actionCreator from 'utils/actionCreator';

export const actions = actionCreator('project', [
  'RESET',
  'ALL_PROJECTS_REQUEST',
  'ALL_PROJECTS_SUCCESS',
  'PROJECT_REQUEST',
  'PROJECT_SUCCESS',
  'ADD_NEW_PROJECT',
  'SHARE_PROJECT',
  'DELETE_PROJECT',
  'UPDATE_PROJECT_TITLE',
  'TOGGLE_CURRENT_PROJECT_LOADING',
  'TOGGLE_ADD_PROJECT_MODAL',
  'TOGGLE_SHARE_PROJECT_MODAL',
  'UPDATE_PROJECT_USERS',
  'CANCEL_PROJECTS_LISTENER',
  'UPDATE_PROJECT_SHARED',
  'UPDATE_PROJECT_APPROVERS',
  'UPDATE_TRELLO_BOARD',
  'CHANGE_PROJECTS_USER_ACCESS',
  'UPDATE_PROJECT_THUMBNAIL',
]);

export function resetProject() {
  return {
    type: actions.RESET,
  };
}

export function allProjectsRequest() {
  return {
    type: actions.ALL_PROJECTS_REQUEST,
  };
}

export function allProjectsSuccess(payload) {
  return {
    type: actions.ALL_PROJECTS_SUCCESS,
    payload,
  };
}

export function projectRequest(payload, navigate) {
  return {
    type: actions.PROJECT_REQUEST,
    payload,
    navigate,
  };
}

export function projectSuccess(payload) {
  return {
    type: actions.PROJECT_SUCCESS,
    payload,
  };
}

export function addNewProject(payload, navigate) {
  return {
    type: actions.ADD_NEW_PROJECT,
    payload,
    navigate,
  };
}

export function shareProject(payload, callback) {
  return {
    type: actions.SHARE_PROJECT,
    payload,
    callback,
  };
}

export function deleteProject(payload) {
  return {
    type: actions.DELETE_PROJECT,
    payload,
  };
}

export function updateProjectTitle(payload) {
  return {
    type: actions.UPDATE_PROJECT_TITLE,
    payload,
  };
}

export function toggleCurrentProjectLoading(payload) {
  return {
    type: actions.TOGGLE_CURRENT_PROJECT_LOADING,
    payload,
  };
}

export function toggleAddProjectModal(payload) {
  return {
    type: actions.TOGGLE_ADD_PROJECT_MODAL,
    payload,
  };
}

export function toggleShareProjectModal(payload) {
  return {
    type: actions.TOGGLE_SHARE_PROJECT_MODAL,
    payload,
  };
}

export function updateProjectUsers(payload) {
  return {
    type: actions.UPDATE_PROJECT_USERS,
    payload,
  };
}

export function cancelProjectsListener() {
  return {
    type: actions.CANCEL_PROJECTS_LISTENER,
  };
}

export function updateProjectShared(payload) {
  return {
    type: actions.UPDATE_PROJECT_SHARED,
    payload,
  };
}

export function updateProjectApprovers(payload) {
  return {
    type: actions.UPDATE_PROJECT_APPROVERS,
    payload,
  };
}

export function updateProjectTrelloBoard(payload) {
  return {
    type: actions.UPDATE_TRELLO_BOARD,
    payload,
  };
}

export function changeProjectsUserAccess(payload) {
  return {
    type: actions.CHANGE_PROJECTS_USER_ACCESS,
    payload,
  };
}

export function updateProjectThumbnail(payload) {
  return {
    type: actions.UPDATE_PROJECT_THUMBNAIL,
    payload,
  };
}
